import config from '../../../../config/config';
import { Configuration, FilesModuleApi } from '../../../../generate/api';
import { getAuthorizationToken } from '../../../../redux/keyclock/middleware';
import { store } from '../../../../redux/store';

export const filesApi = new FilesModuleApi(
    new Configuration({
        basePath: config.api.baseUrl,
        accessToken: () => {
            return store.getState().keycloak.token as string;
        },
    }),
);
